import { Body, Logo, useLanguage } from "@/lib/main";
import { CSSProperties, PropsWithChildren } from "react";
import { Link } from "react-router";

type Props = PropsWithChildren<{ logo?: string; slogan?: string; to?: string }>;

export default function FooterLogo({ children, logo, slogan, to }: Props) {
  const { language } = useLanguage();

  const linkStyle: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "var(--spacing-sm)",

    padding: "var(--spacing-lg)",

    color: "var(--color-text-always-light",
  };

  return (
    <Link
      aria-label={language === "en" ? "Home" : "الرئيسة"}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      style={linkStyle}
      to={to ? to : "/"}
      title={language === "en" ? "Home" : "الرئيسة"}
    >
      {children}
      {logo ? (
        <>
          <p
            style={{
              fontSize: "1.9rem",
              fontWeight: 800,
              textAlign: "center",
            }}
          >
            {logo}
          </p>
          {slogan ? (
            <Body
              color="always-light"
              fontWeight={500}
              size="md"
              textAlign="center"
            >
              {slogan}
            </Body>
          ) : null}
        </>
      ) : (
        <>
          <Logo name="white" size="md" />
          {slogan ? (
            <Body
              color="always-light"
              fontWeight={500}
              size="md"
              textAlign="center"
            >
              {slogan}
            </Body>
          ) : null}
        </>
      )}
    </Link>
  );
}
